export type PayerNaming = {
    Order: string;
    Orders: string;
    Project: string;
    projects: string;
    project: string;
    Projects: string;
    orders: string;
    order: string;
};

const USE_NEW_NAMING = true;

export const PAYER_NAMING: PayerNaming = USE_NEW_NAMING
    ? {
          order: 'project',
          Order: 'Project',
          orders: 'projects',
          Orders: 'Projects',
          project: 'project type',
          Project: 'Project Type',
          projects: 'project types',
          Projects: 'Project Types',
      }
    : {
          order: 'order',
          Order: 'Order',
          orders: 'orders',
          Orders: 'Orders',
          project: 'project',
          Project: 'Project',
          projects: 'projects',
          Projects: 'Projects',
      };
